<template>
    <div>
        <b-card
                header="Create Message"
                header-text-variant="white"
                header-bg-variant="info"
        >
            <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)">
                <b-form-group label="Recipients" >
                    <user-search-dropdown
                        placeholder="Add Recipient"
                        icon="fa-plus"
                        :formatter="searchDisplay"
                        @selectUser="addUser"
                        :type="type"
                        :carrier-based="true"
                        @changeCarrier="changeCarrier"
                        :disabled="bulkSelected == 1"
                        class="mb-2"
                    />

                    <div class="user-pills" v-show="!bulkSelected">
                        <b-badge pill
                                 :href="`/business/${user.role_type}s/${user.id}`"
                                 target="_blank"
                                 v-for="user in selectedUsers"
                                 :key="user.id"
                                 variant="light">
                            {{ searchDisplay(user) }}

                            <a href="#" class="delete-btn" @click.stop="removeUser(user.id)"><i class="fa fa-times"></i></a>
                        </b-badge>
                    </div>
                    <input-help :form="form" field="recipients" text=""></input-help>
                </b-form-group>
                <b-form-group label="Bulk Options" v-show="form.carrier != ''">
                    <div class="form-check" disabled="true">
                        <b-form-checkbox v-model="form.allEnrolledClients" :true-value="1" :false-value="0">Select all Enrolled Claimants</b-form-checkbox>
                    </div>
                    <div class="form-check">
                        <b-form-checkbox v-model="form.allEnrolledCaregivers" :true-value="1" :false-value="0">Select all Enrolled Providers</b-form-checkbox>
                    </div>
                </b-form-group>
                <b-form-group label="Subject" v-if="subject">
                    <b-input v-model="form.subject" placeholder="Subject Line" maxlength="77"></b-input>
                    <input-help :form="form" field="subject" text=""></input-help>
                </b-form-group>
                <b-form-group label="Message">
                    <b-textarea :rows="6" v-model="form.message"></b-textarea>
                    <input-help :form="form" field="message" text=""></input-help>
                </b-form-group>
                <b-form-group>
                    <b-button variant="info" @click="sendBlast()" :disabled="submitting"><i class="fa fa-spin fa-spinner" v-if="submitting"></i> Send</b-button>
                </b-form-group>
            </form>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "BusinessSendBlast",

        props: {
            'subject': Boolean,
            'submissionUrl': String,
            'type': String,
        },

        data() {
            return {
                'selectedUsers': [],
                'form': new Form({}),
                'numOfSets': 3,
                'submitting': false,
            }
        },

        mounted() {
            this.resetForm();
        },

        computed: {
            bulkSelected() {
                return this.form.allEnrolledCaregivers || this.form.allEnrolledClients;
            },
        },

        methods: {
            changeCarrier(val) {
                this.form.carrier = val;
            },

            addUser(user) {
                this.removeUser(user.id);   // prevent duplicates
                this.selectedUsers.push(user);
            },

            removeUser(id) {
                let index = this.selectedUsers.findIndex(item => item.id === id);
                if (index !== -1) this.selectedUsers.splice(index, 1);
            },

            searchDisplay(user) {
                switch(this.type) {
                    case 'phone':
                    case 'sms':
                        return `${user.name} ${user.phone}` + (user.carrier ? ` - ${user.carrier}` : '');
                    default:
                        return `${user.name} ${user.email}` + (user.carrier ? ` - ${user.carrier}` : '');
                }
            },

            async sendBlast()
            {
                if (! confirm('Are you sure you wish to send this ' + this.type + ' to the selected recipients?')) return;
                this.submitting = true;
                try {
                    this.form.recipients = this.getRecipients();
                    await this.form.post(this.submissionUrl);
                    this.resetForm();
                }
                catch (e) {}
                this.submitting = false;
            },

            getRecipients()
            {
                if (this.bulkSelected) return [];
                return this.selectedUsers.map(item => item.id);
            },

            resetForm()
            {
                this.form = new Form({
                    'subject': '',
                    'message': '',
                    'recipients': [],
                    'allEnrolledClients': 0,
                    'allEnrolledCaregivers': 0,
                    'carrier': '',
                });
                this.selectedUsers = [];
            },
        }
    }
</script>
